import {
  Component,
  NgModule,
  Output,
  Input,
  EventEmitter,
  ViewChild,
  ElementRef,
  AfterViewInit,
  OnDestroy,
} from '@angular/core';

import {
  DxTreeViewModule,
  DxTreeViewComponent,
  DxTreeViewTypes,
} from 'devextreme-angular/ui/tree-view';
import * as events from 'devextreme/events';
import { CommonModule } from '@angular/common';
import { DkNavService } from '../../../services/dk-nav.service';
import { Observable, Subject, take, takeUntil } from 'rxjs';
import {
  DxButtonModule,
  DxContextMenuComponent,
  DxContextMenuModule,
  DxPopoverModule,
  DxPopupModule,
  DxResizableModule,
  DxScrollViewModule,
  DxTextBoxModule,
  DxButtonGroupModule,
  DxTextBoxComponent
} from 'devextreme-angular';
import { DkModulesComponent } from '../dk-modules/dk-modules.component';
import { DevMenuModel } from './navigation';
import { menuIkonCoz, yedekRenk } from './menu-gorunum';
import { OrtakService } from '../../../services/ortak.service';
import { SearchMode } from 'devextreme/common';
import { InputEvent } from 'devextreme/ui/text_box';
import { DxButtonTypes } from 'devextreme-angular/ui/button';
import { a } from '@dabnet-kamu/libs/ui';
import { Router } from '@angular/router';
import { ACILIR_MENU_AKTIF, DkAcilirMenuComponent } from '../dk-acilir-menu/dk-acilir-menu.component';

@Component({
  selector: 'dk-side-navigation-menu',
  templateUrl: './dk-side-navigation-menu.component.html',
  styleUrls: ['./dk-side-navigation-menu.component.scss'],
  standalone: true,
  imports: [
    CommonModule,
    DxTreeViewModule,
    DxButtonModule,
    DxPopupModule,
    DkModulesComponent,
    DxScrollViewModule,
    DxPopoverModule,
    DxContextMenuModule,
    DxResizableModule,
    DxTextBoxModule,
    DxButtonGroupModule,
    DkAcilirMenuComponent
  ],
})
export class DkSideNavigationMenuComponent implements AfterViewInit, OnDestroy {
  public menuItems: any[] = [
    { id: 'addFav', text: 'Favorilere Ekle' },
    { id: 'removeFav', text: 'Favorilerden Kaldır' },
  ];
  handles: string[] = ['right'];
  public formId: number;
  public menuType: string;
  public menuTitle = 'Tüm Uygulamalar';
  @ViewChild(DxTreeViewComponent, { static: true })
  menu!: DxTreeViewComponent;
  @ViewChild(DxContextMenuComponent, { static: false })
  contextMenu: DxContextMenuComponent;
  @ViewChild('searchBox', { static: false })
  searchBox: DxTextBoxComponent;

  menulist$: Observable<DevMenuModel[]>;
  favlist$: Observable<DevMenuModel[]>;
  @Output()
  selectedItemChanged = new EventEmitter<DxTreeViewTypes.ItemClickEvent>();
  @Output()
  openMenu = new EventEmitter<any>();
  /** Açılır menü şeridindeki "genişlet" düğmesi: ağaç menü kalıcı açılsın (MainComponent menuOpened). */
  @Output()
  menuyuGenislet = new EventEmitter<void>();

  /** Açılır menü (16.10.2026, deneme): daraltılmışken ağaç yerine ikon şeridi + basamaklı pencereler. */
  readonly acilirMenuAktif = ACILIR_MENU_AKTIF;
  get acilirGoster(): boolean {
    return this.acilirMenuAktif && this._compactMode;
  }
  crudShowModule = false;
  @Input()
  get compactMode() {
    return this._compactMode;
  }

  set compactMode(val: boolean) {
    this._compactMode = val;
    this.daraltilmisIpuclari();
    if (!this.menu?.instance) {
      return;
    }
    if (val) {
      this.menu.instance.collapseAll();
    } else {
      this.menu.instance.expandItem(this._selectedItem);
    }
  }

  @Input()
  set selectedItem(value: string) {
    this._selectedItem = value;
    this.setSelectedItem();
  }

  get selectedItem(): string {
    return this._selectedItem.toString();
  }

  private _selectedItem!: string;

  private _compactMode = false;

  filteredMenuList: DevMenuModel[] = [];
  allMenuList: DevMenuModel[] = [];

  searchWithChild:boolean = false;

  withChildBtnOptions: DxButtonTypes.Properties = {
    stylingMode: 'text',
    text:"",
    type:"default",
    icon:"detailslayout",
    hint:"Detaylı Arama",
    onClick: ($event) => {
      this.withChildBtnClick($event)
    },
  };
 
  collapseBtnOptions :DxButtonTypes.Properties = {
      stylingMode: 'text',
      text:"",
      type:"default",
      icon:"collapse",
      hint:"Tümü Daralt",
      onClick: ($event) => {
        this.collapseBtnClick($event)
      },
    };  

    clearBtnOptions :DxButtonTypes.Properties = {
      stylingMode: 'text',
      text:"",
      type:"default",
      icon:"clear",
      hint:"Temizle",
      elementAttr: {
        class: 'clearBtn',
      },
      onClick: ($event) => {
        this.searchBox.instance.option('value','')
        this.filteredMenuList = this.allMenuList;
        this.menu.instance.collapseAll();
      },
    }

  private destroy$ = new Subject<void>();
  constructor(
    private elementRef: ElementRef,
    private service: DkNavService,
    private ortakServices: OrtakService,
    private router:Router
  ) {
 
  }


  /**
   * 11.10.2026: DaBNet logosunun altındaki sürüm satırı ("2026.1011.200555 · 2116b6a57").
   * Derleme sonunda tools/surum-yaz.js yazar (dist/apps/dabnet-kamu/surum.json); ng serve'de dosya yok → satır görünmez.
   */
  surum = '';

  ngOnInit() {
    fetch('surum.json', { cache: 'no-store' })
      .then((r) => (r.ok ? r.json() : null))
      .then((s) => (this.surum = [s?.surum, s?.commit].filter(Boolean).join(' · ')))
      .catch(() => undefined);
    this.favlist$ = this.service.favNavigation$;
    this.service.navigation$.pipe(takeUntil(this.destroy$)).subscribe((list) => {
      this.filteredMenuList = list;
      this.allMenuList = list;
    });
  }



  withChildBtnClick(e:any){
    if(this.withChildBtnOptions.stylingMode == 'text'){
      this.withChildBtnOptions = {...this.withChildBtnOptions,stylingMode:'contained'};
      this.searchWithChild = true;
    }else{
      this.withChildBtnOptions = {...this.withChildBtnOptions,stylingMode:'text'};
      this.searchWithChild = false;
    }

    this.searchMenu({
      component: this.searchBox.instance,
      element: this.searchBox.instance.element(),
      event: {
        target: { value: this.searchBox.instance.option('value') }
      }
    } as InputEvent);
  }

  collapseBtnClick(e:any){
    this.menu.instance.collapseAll();
  }

  showSelectModule() {
    this.crudShowModule = true;
  }

  setSelectedItem() {
    if (!this.menu?.instance) {
      return;
    }

    this.menu.instance.selectItem(this.selectedItem);
  }

  onItemClick(event?: DxTreeViewTypes.ItemClickEvent) {
    let res: any = event;
    if (res.itemData.path) {
    }
    this.selectedItemChanged.emit(event);
    this.service.addButtonHandler(event);
  }

  ngAfterViewInit() {
    this.setSelectedItem();
    // eski hâli (16.10.2026):
    // events.on(this.elementRef.nativeElement, 'dxclick', (e: Event) => {
    //   this.openMenu.next(e);
    // });
    events.on(this.elementRef.nativeElement, 'dxclick', (e: Event) => {
      // Açılır menüde şeride tıklamak paneli açmaz; pencere açar (genişletme şeridin altındaki düğmeyle)
      if (this.acilirGoster) return;
      this.openMenu.next(e);
    });
  }

  ngOnDestroy() {
    events.off(this.elementRef.nativeElement, 'dxclick');
      this.destroy$.next();
      this.destroy$.complete();
  }

  contextMenuItemClick(e: any) {
    let isCheck: boolean;
    if (e.itemData.id === 'addFav') isCheck = false;
    else isCheck = true;
    this.ortakServices
      .addForm2Favorite(this.formId, isCheck)
      .subscribe((res) => {
        if (res) {
          this.service.getFav(false);
        }
      });
  }
  treeViewItemContextMenu(e: any) {
    this.menuType = e.itemData.menuType;
    if (
      e.itemData.menuType === 'Form' ||
      e.itemData.menuType === 'ReportForm'
    ) {
      this.formId = e.itemData.formId;
      this.favlist$.pipe(take(1)).subscribe((res) => {
        const isVisible = res.find((x) => x.formId == this.formId);
        const contextMenu = this.contextMenu.instance;
        contextMenu.option('items[0].visible', isVisible ? false : true);
        contextMenu.option('items[1].visible', isVisible ? true : false);
      });
    }
  }
  closedPopover(e: any) {
    this.crudShowModule = false;
    this.menuTitle = e.menuTitle;
    // Seçilen modülün ikonu/rengi butona geçer; "Tüm Uygulamalar" (moduleId 0) varsayılan ızgara ikonu.
    const gorunum = menuIkonCoz(e?.icon);
    const modul = e?.moduleId > 0;
    this.modulIkonSinif = modul && gorunum.ikon ? this.ikonSinifi(gorunum.ikon) : 'dx-icon-mediumiconslayout';
    this.modulRenk = modul ? (gorunum.renk ?? yedekRenk(e.moduleId)) : null;
  }

  /** "Tüm Uygulamalar" butonunun ikonu/rengi (null → tema vurgusu). */
  modulIkonSinif = 'dx-icon-mediumiconslayout';
  modulRenk: string | null = null;

  private ikonSinifi(ikon: string): string {
    // FontAwesome sınıfı aynen; DevExtreme ikon adı 'dx-icon-<ad>' olur.
    return ikon.includes('fa-') ? ikon : `dx-icon-${ikon}`;
  }

  /**
   * 17.10.2026: açılır menüdeki ☆ / sağ tık — ağaçtaki "Favorilere Ekle / Kaldır" ile aynı servis çağrısı
   * (addForm2Favorite'in ikinci parametresi "kaldır mı"), başarılıysa favori listesi tazelenir.
   */
  acilirFavoriDegistir(e: { oge: DevMenuModel; ekle: boolean }) {
    const formId = e?.oge?.formId;
    if (!formId) return;
    this.ortakServices.addForm2Favorite(formId, !e.ekle).subscribe((res) => {
      if (res) this.service.getFav(false);
    });
  }

  /** Açılır menüden seçilen form: ağaçtaki tıklamayla aynı yoldan sekmede açılır. */
  acilirFormSec(oge: DevMenuModel) {
    this.service.addButtonHandler({ itemData: oge });
  }

  /**
   * Daraltılmış (45px) menüde ad yazısı gizlidir (16.10.2026); ikonun üstüne gelince adı ipucu olarak çıksın.
   * Geniş menüde ipucu kaldırılır (yazı zaten görünüyor).
   */
  private daraltilmisIpuclari() {
    const kok = this.elementRef?.nativeElement as HTMLElement | undefined;
    kok?.querySelectorAll<HTMLElement>('.dx-treeview-item').forEach((el) => this.ipucuYaz(el));
  }

  private ipucuYaz(el: HTMLElement | null | undefined) {
    if (!el) return;
    const ad = el.querySelector('.dx-treeview-item-content span')?.textContent?.trim();
    if (this._compactMode && ad) el.setAttribute('title', ad);
    else el.removeAttribute('title');
  }

  /** Ağaç düğümüne modül rengini (--r) yazar; alt düğümler ve kılavuz çizgisi bunu miras alır. */
  onItemRendered(e: DxTreeViewTypes.ItemRenderedEvent) {
    this.ipucuYaz(e.itemElement as HTMLElement);
    const dugum = (e.itemElement as HTMLElement)?.parentElement;
    if (!dugum) return;
    const renk = (e.itemData as DevMenuModel)?.renk;
    if (renk) dugum.style.setProperty('--r', renk);
    else dugum.style.removeProperty('--r');
  }

  searchMenu(event: InputEvent) {
    const searchText = event.event.target.value; 
    if (this.searchWithChild == true && searchText.length > 0) {
      this.filteredMenuList = [];
      this.filteredMenuList = this.filterIncludChildNodes(
        this.allMenuList,
        searchText
      );
      if(searchText.length > 0){
        this.expandNodes(this.filteredMenuList);
      }
    }else if(this.searchWithChild == false && searchText.length > 0){
      this.filteredMenuList = [];
      this.filteredMenuList = this.filterNodes(this.allMenuList, searchText);
      if(searchText.length > 0){
        this.expandNodes(this.filteredMenuList);
      }

    }else{
      this.filteredMenuList = this.allMenuList;
      this.menu.instance.collapseAll(); 
      
    }
  }

  expandNodes(items: DevMenuModel[]) {
    if (items.length === 0) return;
    else {
      items.forEach((item) => {
        item.expanded = true;
        this.expandNodes(item.items);
      });
    }
  }

  expandNodesSmooth(items: DevMenuModel[]) {
  const stack: DevMenuModel[] = [...items];

  const processChunk = () => {
    // Her turda çok az node expand ediliyor
    const chunk = stack.splice(0, 200);

    chunk.forEach(n => {
      n.expanded = true;

      if (n.items && n.items.length > 0) {
        stack.push(...n.items);
      }
    });

    if (stack.length > 0) {
      // UI kitlenmesin diye node’ları parça parça genişlet
      requestAnimationFrame(processChunk);
    }
  };

  processChunk();
}

  filterIncludChildNodes(menu: DevMenuModel[], searchTerm: string) {
    return menu
      .map((item) => {
        // Clone the item
        const newItem = { ...item };

        // Eğer parent eşleşiyorsa tüm alt öğeleri ekle
        const matches = newItem.text
          ?.toLocaleLowerCase('tr')
          .includes(searchTerm.toLocaleLowerCase('tr'));
        if (matches) {
          // Eğer parent eşleşiyorsa alt dallar olduğu gibi eklenir
          return newItem;
        }

        // Alt öğeleri filtrele
        if (item.items && item.items.length > 0) {
          newItem.items = this.filterIncludChildNodes(item.items, searchTerm);
        }

        // Eğer parent eşleşmiyorsa ama alt dallar eşleşiyorsa parent'i de dahil et
        const hasMatchingChildren = newItem.items && newItem.items.length > 0;
        return hasMatchingChildren ? newItem : null;
      })
      .filter((item) => item !== null); // Remove null items
  }

  filterNodes(menu: DevMenuModel[], searchTerm: string): DevMenuModel[] {
    return menu
      .map((item) => {
        // Clone the item
        const newItem = { ...item, items: [] as DevMenuModel[] };
  
        // Eğer düğüm eşleşiyorsa işaretle
        const matches = newItem.text
          ?.toLocaleLowerCase('tr')
          .includes(searchTerm.toLocaleLowerCase('tr'));
  
        // Alt öğeleri filtrele
        if (item.items && item.items.length > 0) {
          newItem.items = this.filterNodes(item.items, searchTerm);
        }
  
        // Eğer parent veya herhangi bir alt öğe eşleşiyorsa parent'i de dahil et
        return matches || (newItem.items && newItem.items.length > 0) ? newItem : null;
      })
      .filter((item) => item !== null); // Null olanları kaldır
  }


  routeMain(){
    this.router.navigate(['/main/dabnet']);
  }

 
}
